import Article from "./Article";
import RealAux from './../../hoc/RealAux';

const Articles= function (props) {
    return (
        // <RealAux >
            <div className="cards">
            {props.items.map((item,index) => (
            <Article data={item} key={"article_"+index}/>
        )) }
        </div>
        // {/* </RealAux> */}
    )
}
export default Articles;